
<template>
  
    <div id="studyIntervalButtons">
      <div class="btn-group btn-group-justified">
        <a @click.prevent="setMicroNoteNextStudy(0)" class="btn btn-repeat btn-default btn-lg"><span>Repeat - </span>Now</a>
        <a @click.prevent="setMicroNoteNextStudy(24)" class="btn btn-hard btn-default btn-lg"><span>Hard - </span>1 Day</a>
        <a @click.prevent="setMicroNoteNextStudy(72)" class="btn btn-medium btn-default btn-lg"><span>Good - </span>3 Days</a>
        <a @click.prevent="setMicroNoteNextStudy(168)" class="btn btn-easy btn-default btn-lg"><span>Easy - </span>1 Week</a>
      </div>
    </div>
</template>

<script>
  import { mapState, mapGetters} from 'vuex'
import Vue from 'vue'
import moment from 'moment-timezone'



export default {
  props: ['microNote'],
  // components: {
  //   WordbankWord,
  // },
    computed: {
      ...mapState([
        'currentUser',
      ]),
      ...mapGetters(['currentMicroNote']),
    },

  methods: {

    setMicroNoteNextStudy(hoursFromNow) {
      const _this = this;
      // “repeat” (they will be represented the same card again)
      // “hard”, = 24 hours
      // “good”  = 3 days
      // “easy”. = 1 week
      // #todo - set last_studied_at

      const now = moment();
      const nextStudyAt = now.clone().add(hoursFromNow, 'hours');

      console.log(`setting nextStudyAt for microNote #${this.microNote.id} to ${hoursFromNow} hours from now.`)
      const payload = {
        id: this.microNote.id,
        changes:  {
          last_studied_at: now.toISOString(),
          next_study_at: nextStudyAt.toISOString(),
        },
        callback(err) {
          if( !err) {
            // _this.$store.dispatch('studier/nextMicroNote'); // automatically goes to the next one
            window.scrollTo(0, 0);
            if (hoursFromNow <= 0 && _this.currentUser.studySort !== 'next_study_at') {
              _this.$store.dispatch('studier/nextMicroNote');
            } else if (!this.currentMicroNote) {
              _this.$store.dispatch('studier/nextMicroNote');
            }
          }
        }
      }

      this.$store.dispatch('updateMicroNote', payload)
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

#studyIntervalButtons {
  position: absolute;
  bottom: 10px;
  padding: 0 15px;

  .btn {
    padding:20px 0px;
  }

  .btn-hard {
    border-bottom: 2px solid #ea4335;
  }

  .btn-medium {
    border-bottom: 2px solid #fbbf0f;
  }

  .btn-easy {
    border-bottom: 2px solid #34a853;
  }

  .btn-repeat {
    border-bottom: 2px solid #4285f4;
  }
}

  @media (max-width:600px) {
    .btn-group-justified .btn span { display:none; }
  }

</style>



// WEBPACK FOOTER //
// StudyIntervalButtons.vue?709e77e2